import { type Entry, type Properties } from './types/cit-public-api';

const hasName = 'hasName';
const hasDescription = 'hasDescription';
const hasClass = 'hasClass';
const hasUpdateDate = 'hasUpdateDate';

export const hasNamePath = [hasName, 'value_text'];
export const hasClassPath = [hasClass, 'value_text'];
export const hasDescriptionPath = [hasDescription, 'value_text'];
export const hasUpdateDatePath = [hasUpdateDate, 'value_date'];

export const PLACEHOLDER_ENTRY: Entry = {
  id: 'uuid',
  slug: 'uuid',

  account_id: '',
  account_slug: '',

  classification: '',
  classification_v2: '',

  properties: {
    hasName: { value_text: '' }
  },

  folder_ids: [],
  next_id: null,
  prev_id: null
};

/**
 * Get the property at "path" from a "obj" Properties object
 *
 * @param obj
 * @param path
 * @returns
 */

export function getProperty(obj: Properties, path: string[]) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return path.reduce((o, k) => o?.[k], obj) as any;
}

/**
 * Returns name property.  Because this is so common it makes sense to have a dedicated helper function
 *
 * @param obj
 * @returns
 */
export function getName(obj: Properties): string {
  return getProperty(obj, hasNamePath) as string;
}

export function getDescription(obj: Properties): string {
  return getProperty(obj, hasDescriptionPath) as string;
}
